<p class="pad-subtext-section-title-mobile">{{ contentService.content().mainPage.whyMe.aboutMe }}</p>

<div>
    <h3>{{ contentService.content().mainPage.whyMe.iAm }}<span>:</span></h3>
    
    <div id="argument-block-container">
        @for (item of contentService.content().mainPage.whyMe.singleArguments | keyvalue; track item.key) {
        <div class="argument-block">
            <app-dynamic-svg [imgName]="item.key" [folder]="'why-me'"></app-dynamic-svg>
            
            <p>{{ item.value }}</p>
        </div>
        }
    </div>
</div>